import { render, staticRenderFns } from "./VasionTable.vue?vue&type=template&id=56cf4d08&scoped=true&"
import script from "./VasionTable.vue?vue&type=script&lang=js&"
export * from "./VasionTable.vue?vue&type=script&lang=js&"
import style0 from "./VasionTable.vue?vue&type=style&index=0&id=56cf4d08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf4d08",
  null
  
)

export default component.exports